import { css } from 'linaria';

export const productInfo = css`
  width: 422px;
  padding: 24px;

  @media (--only-largeDesktop) {
    margin-top: 40px;
  }

  @media (--only-desktop) {
    width: 332px;
    margin-top: 38px;
  }

  @media (--from-desktop) {
    box-shadow: var(--box-shadow-m);
    border-radius: var(--rounding-l);
  }

  @media (--to-desktop) {
    width: 100%;
  }

  @media (--only-mobile) {
    padding: 16px 16px 0 16px;
  }
`;

export const productInfoName = css`
  && {
    margin-bottom: 12px;
  }
`;

export const productOnfoCashbackWrapper = css`
  margin-bottom: 32px;

  @media (--only-mobile) {
    margin-bottom: 16px;
  }
`;

export const productInfoVariantsContainer = css`
  padding: 12px 0;
  border: unset;
  background: none;
  width: 100%;
`;

export const productInfoVariants = css`
  && {
    opacity: 1;
    
    span {
      background-color: var(--control-invert);
    }

    fieldset {
      cursor: pointer;

      @media (--only-mobile) {
        border-top: none;
        border-right: none;
        border-left: none;
        border-radius: 0;
      }
    }
  }
`;

export const productInfoPriceContainer = css`
  padding: 16px 0;
`;

export const productInfoDisclaimer = css`
  display: flex;
  margin-bottom: 16px;
  column-gap: 8px;
  cursor: pointer;
  border: unset;
  background: none;
`;

export const productInfoDisclaimerIcon = css`
  && {
    @media (--only-desktop) {
      width: 15px;
      height: 15px;
    }
  }
`;

export const productInfoDisclaimerText = css`
  && {
    @media (--only-desktop) {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

export const productInfoBasketBtnWrapper = css`
  width: 100%;
`;
